import Grid from '@material-ui/core/Grid';
import GridFormField from 'shared/components/GridFormField';
import React from 'react';
import removeHTML from 'shared/utils/removeHTML';
import Typography from '@material-ui/core/Typography';
import {
	dateInRange,
	isAfterDob,
	isAfterDateInField,
	isBeforeDateInField,
	maxStrLength,
	settingValidation,
	restrictedTextInputValidation,
} from 'shared/utils/validations';
import { FormSection } from 'redux-form';
import { PropTypes } from 'prop-types';
import {
	DATE_RANGE_START_YEAR,
	DATE_RANGE_START_MONTH,
	DATE_RANGE_START_DAY,
	PREVIOUS_EMPLOYMENT,
} from './constants';

const PreviousEmploymentFields = ({ disableAll, settings, name }) => (
	<FormSection name={name} style={{ width: '100%' }}>
		<Grid container spacing={5}>
			<GridFormField
				fieldSettings={settings.primary.previousEmployer}
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousEmployerLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousEmployerDescription}
				name="name"
				validation={[
					settingValidation(settings.primary.previousEmployer),
					maxStrLength(30),
					restrictedTextInputValidation,
				]}
				disabled={disableAll}
			/>
			<GridFormField
				fieldSettings={settings.primary.previousTimeAtEmployer}
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousEmploymentStartLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousEmploymentStartDescription}
				type="date"
				inputProps={{
					 style: { textTransform: 'uppercase', marginTop: '16px' },
					 placeholder: 'MM/dd/yyyy' }}
				labelShrink
				name="employmentTermStartDate"
				validation={[
					settingValidation(settings.primary.previousTimeAtEmployer),
					dateInRange(
						new Date(DATE_RANGE_START_YEAR, DATE_RANGE_START_MONTH, DATE_RANGE_START_DAY),
						new Date(Date.now()),
					),
					isBeforeDateInField(`${name}.employmentTermEndDate`),
					isAfterDob,
				]}
				disabled={disableAll}
			/>
			<GridFormField
				fieldSettings={settings.primary.previousTimeAtEmployer}
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousEmploymentEndLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousEmploymentEndDescription}
				type="date"
				inputProps={{ 
					style: { textTransform: 'uppercase', marginTop: '16px' }, 
					placeholder: 'MM/dd/yyyy' }}
				labelShrink
				name="employmentTermEndDate"
				validation={[
					settingValidation(settings.primary.previousTimeAtEmployer),
					dateInRange(
						new Date(DATE_RANGE_START_YEAR, DATE_RANGE_START_MONTH, DATE_RANGE_START_DAY),
						new Date(Date.now()),
					),
					isAfterDateInField(`${name}.employmentTermStartDate`),
				]}
				disabled={disableAll}
			/>
		</Grid>
		<Typography type="caption" component="div" style={{ paddingTop: '20px' }}>
			<div
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{
					__html: removeHTML(settings.fieldAndFooterSettings.ApplicationPageSettings.PreviousEmploymentFooter),
				}}
			/>
		</Typography>
	</FormSection>
);

PreviousEmploymentFields.propTypes = {
	disableAll: PropTypes.bool,
	settings: PropTypes.shape({
		primary: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
	}),
	name: PropTypes.string,
};

PreviousEmploymentFields.defaultProps = {
	disableAll: false,
	settings: {},
	name: PREVIOUS_EMPLOYMENT,
};

export default PreviousEmploymentFields;
